const Ajax = require('common/infra/ajax');

class API {
    constructor() {
        // TODO: 本来 API は Cursor を保持するべきではない
        this._cursors = {};
        this._mores = {};
    }

    _basePath(projectID, actionID) {
        return `/api/projects/${projectID}/actions/${actionID}/diagrams`;
    }

    create(projectID, actionID, diagramJSON) {
        const path = this._basePath(projectID, actionID);
        return Ajax.POST(path, diagramJSON);
    }

    addDiagram(projectID, actionID, diagramIDs) {
        const path = `/api/projects/${projectID}/actions/${actionID}/add-diagrams`;
        return Ajax.POST(path, diagramIDs);
    }

    updateRelation(projectID, actionWorkID, relation) {
        let path = `/api/projects/${projectID}/action-works/diagram/${actionWorkID}/relation?`;
        if(relation.input) {
            path += 'relation=in&';
        }
        if(relation.output) {
            path += 'relation=out';
        }
        return Ajax.GET(path);
    }

    delete(projectID, actionWorkID) {
        const path = `/api/projects/${projectID}/action-works/diagram/${actionWorkID}`;
        return Ajax.DELETE(path);
    }

    /**
    /**
     * Action 配下の Diagram Work 一覧を取得する
     *
     * @param projectID
     * @param actionID
     * @param limit
     * @returns {*}
     */
    getNext(projectID, actionID, limit) {
        const path = this._basePath(projectID, actionID);
        let extraHeaders = {};
        if(_.has(this._cursors, path)) {
            extraHeaders['X-Datastore-Cursor'] = this._cursors[path];
        }

        return Ajax.GET(`${path}?limit=${limit}`, {
            withResponseHeaders: true,
            extraHeaders: extraHeaders
        })
            .then(value => {
                this._cursors[path] = value.headers.get('X-Datastore-Cursor');
                this._mores[path] = value.headers.get('X-Datastore-More') == 'true';

                return value.data;
            });
    }

    hasNext(projectID, actionID) {
        const path = this._basePath(projectID, actionID);
        return _.has(this._mores, path) && this._mores[path];
    }
}

module.exports = new API();



// WEBPACK FOOTER //
// ./balus/infra/api/actionwork/diagram.js